
import ReactComponent from "./register-react-component"
import thesignaturetours from "./thesignaturetours"
import gd from "./gd"
import gd_sg from "./gd_sg"


ReactComponent.setup({thesignaturetours, gd, gd_sg})
